export default __webpack_public_path__ + "static/media/MasukanHeader-in.106782ee.png";